module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/classic_tablet-a625bad3cc7720feb4dd96d3a45aba30.jpg";